import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_tune",
  "use": "micro_tune-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_tune\"><path fill-rule=\"evenodd\" d=\"M2.5 5a2.5 2.5 0 0 1 2.45 2H10v1H4.95A2.5 2.5 0 1 1 2.5 5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5-6a2.5 2.5 0 1 1-2.45 3H0V2h5.05A2.5 2.5 0 0 1 7.5 0Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol